import React, { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Clock, MapPin, Search } from "lucide-react";
import { AVAILABLE_OFFERS } from "../demoData";
import { Card, PageTitle, Badge, Btn, inputCls } from "../ui";

export default function ApplyOffers() {
  const [requested, setRequested] = useState({});
  const [q, setQ] = useState("");
  const list = AVAILABLE_OFFERS.filter((o) => `${o.name} ${o.vertical}`.toLowerCase().includes(q.toLowerCase()));

  const apply = (o) => {
    setRequested((r) => ({ ...r, [o.id]: true }));
    toast.success(`Request sent for ${o.name}. Your manager will review it shortly.`);
  };

  return (
    <>
      <PageTitle title="Apply for Offers" sub="Request access to new campaigns. Google & Meta traffic needs 3 ad screenshots per offer."
        right={
          <div className="relative w-full sm:w-64">
            <Search className="w-4 h-4 text-slate-500 absolute left-3 top-3" />
            <input className={`${inputCls} pl-9`} placeholder="Search offers" value={q} onChange={(e) => setQ(e.target.value)} data-testid="apply-search" />
          </div>
        } />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {list.map((o) => (
          <Card key={o.id} className="p-5 flex flex-col" testId={`apply-offer-${o.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="text-[11px] text-slate-500">{o.id} · {o.vertical}</p>
                <p className="font-semibold text-white">{o.name}</p>
              </div>
              {o.exclusive && <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase text-purple-300 bg-purple-500/15 rounded-full px-2 py-0.5"><Sparkles className="w-3 h-3" />Exclusive</span>}
            </div>
            <p className="mt-4 text-3xl font-extrabold text-white">${o.payout}<span className="text-sm font-medium text-slate-400"> / call</span></p>
            <div className="mt-3 space-y-1.5 text-xs text-slate-400">
              <p className="flex items-center gap-2"><Clock className="w-3.5 h-3.5" />{o.hours}</p>
              <p className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" />{o.states}</p>
            </div>
            <div className="mt-5 pt-4 border-t border-slate-800">
              {requested[o.id] ? (
                <div className="flex items-center justify-between" data-testid={`apply-status-${o.id}`}><span className="text-sm text-slate-400">Status</span><Badge>Requested</Badge></div>
              ) : (
                <Btn className="w-full" onClick={() => apply(o)} data-testid={`apply-btn-${o.id}`}>Request Access</Btn>
              )}
            </div>
          </Card>
        ))}
      </div>
      {!list.length && <p className="text-sm text-slate-500" data-testid="apply-empty">No offers match your search.</p>}
    </>
  );
}
